import {
  Box,
  Grid2,
  Location,
  RowVertical,
  Shop,
} from "iconsax-react";
import type { Icon } from "iconsax-react";
import type { WarehouseResourceType } from "src/services/warehouseService";

interface HierarchyConfig {
  singularKey: string;
  pluralKey: string;
  childPluralKey?: string;
  addKey: string;
  editKey: string;
  emptyKey: string;
  icon: Icon;
  accentClassName: string;
}

export const hierarchyConfig: Record<
  WarehouseResourceType,
  HierarchyConfig
> = {
  warehouse: {
    singularKey: "warehouse",
    pluralKey: "warehouses",
    childPluralKey: "areas",
    addKey: "create_warehouse",
    editKey: "edit_warehouse",
    emptyKey: "no_warehouses_found",
    icon: Shop,
    accentClassName: "bg-primary6 text-primary",
  },
  area: {
    singularKey: "area",
    pluralKey: "areas",
    childPluralKey: "lanes",
    addKey: "create_area",
    editKey: "edit_area",
    emptyKey: "no_areas_found",
    icon: Grid2,
    accentClassName: "bg-[#eef9f4] text-green2",
  },
  lane: {
    singularKey: "lane",
    pluralKey: "lanes",
    childPluralKey: "shelves",
    addKey: "create_lane",
    editKey: "edit_lane",
    emptyKey: "no_lanes_found",
    icon: RowVertical,
    accentClassName: "bg-[#fff7e8] text-orange",
  },
  shelf: {
    singularKey: "shelf",
    pluralKey: "shelves",
    childPluralKey: "positions",
    addKey: "create_shelf",
    editKey: "edit_shelf",
    emptyKey: "no_shelves_found",
    icon: Box,
    accentClassName: "bg-[#f7f2ff] text-purple",
  },
  position: {
    singularKey: "position",
    pluralKey: "positions",
    addKey: "create_position",
    editKey: "edit_position",
    emptyKey: "no_positions_found",
    icon: Location,
    accentClassName: "bg-[#fff0f3] text-red",
  },
};
